export default __webpack_public_path__ + "static/media/program_slide005.453767cc.png";